/* eslint-disable max-len */
/* eslint-disable no-sequences */
import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { NumericInput, PropertyGrid, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Model from "./RefreshLocationCacheDetailModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.details.findAsset.FindAssetModelEditor');
function FindAssetDetailModelEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  if (value == null) {
    return null;
  }
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    style: {
      background: '#FFFFFF'
    },
    children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('styleMinWidth'),
      children: /*#__PURE__*/_jsx(NumericInput, {
        eventData: "setStyleMinWidth",
        min: 0,
        allowError: true,
        value: Model.getStyleMinWidth(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('styleFlexWrap'),
      children: /*#__PURE__*/_jsx(TextInput, {
        eventData: "setStyleFlexWrap",
        allowError: true,
        value: Model.getStyleFlexWrap(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('styleBackground'),
      children: /*#__PURE__*/_jsx(TextInput, {
        eventData: "setStyleBackground",
        allowError: true,
        value: Model.getStyleBackground(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('styleBorderRadius'),
      children: /*#__PURE__*/_jsx(NumericInput, {
        eventData: "setStyleBorderRadius",
        min: 0,
        allowError: true,
        value: Model.getStyleBorderRadius(value),
        onChange: onModelChange
      })
    })]
  });
}
export default /*#__PURE__*/React.memo(FindAssetDetailModelEditor);